import { redactPresignedUrl } from '@/domains/common/services/utils/redactPresignedUrl';
import type { Breadcrumb, BrowserOptions } from '@sentry/vue';

type StreamedSpan = Parameters<NonNullable<BrowserOptions['beforeSendSpan']>>[0];

function redactSentryBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb {
    const url = breadcrumb.data?.url;
    if (typeof url === 'string') {
        breadcrumb.data = { ...breadcrumb.data, url: redactPresignedUrl(url) };
    }

    return breadcrumb;
}

function redactSentrySpan(span: StreamedSpan): StreamedSpan {
    span.name = redactPresignedUrl(span.name);

    Object.entries(span.attributes).forEach(([key, attribute]) => {
        if (typeof attribute === 'string') {
            span.attributes[key] = redactPresignedUrl(attribute);
        }
    });

    return span;
}

export { redactSentryBreadcrumb, redactSentrySpan };
